import { jsx } from 'react/jsx-runtime';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import { memo } from 'react';

const icon = /* @__PURE__ */ jsx(CheckBoxOutlineBlankIcon, { fontSize: "small" });
const checkedIcon = /* @__PURE__ */ jsx(CheckBoxIcon, { fontSize: "small" });
function OptionCheckbox({ selected }) {
  return /* @__PURE__ */ jsx(Checkbox, { icon, checkedIcon, checked: selected });
}
const EntityAutocompletePickerOption = memo((props) => {
  const { selected, value, availableOptions, showCounts } = props;
  const label = showCounts ? `${value} (${availableOptions?.[value]})` : value;
  return /* @__PURE__ */ jsx(
    FormControlLabel,
    {
      control: /* @__PURE__ */ jsx(OptionCheckbox, { selected }),
      label,
      onClick: (event) => event.preventDefault()
    }
  );
});

export { EntityAutocompletePickerOption };
//# sourceMappingURL=EntityAutocompletePickerOption.esm.js.map
